// STAUFF product catalogue definitions shared by the catalogue list and detail pages.
// Catalogues with pdfUrl: null are shown as "Coming soon" until the PDF is uploaded to the CDN.

const CATALOGUE_CDN = 'https://syd1.digitaloceanspaces.com/cdn-assets.mhs/pdfcatalogs';
const IMAGE_BASE = `${process.env.PUBLIC_URL}/resources/catalogue_images`;

export const STAUFF_CATALOGUES = [
  {
    slug: 'clamps',
    title: 'STAUFF Clamps',
    description: 'View online or download the STAUFF Clamps product catalogue.',
    imageUrl: `${IMAGE_BASE}/clamps.jpg`,
    pdfUrl: `${CATALOGUE_CDN}/STAUFF-Catalogue-1-STAUFF-Clamps-English.pdf`,
    fileSize: '46.6 MB',
  },
  {
    slug: 'connect',
    title: 'STAUFF Connect',
    description: 'View online or download the STAUFF Connect product catalogue.',
    imageUrl: `${IMAGE_BASE}/connect.jpg`,
    pdfUrl: `${CATALOGUE_CDN}/STAUFF-Catalogue-2-STAUFF-Connect-English.pdf`,
    fileSize: '69.7 MB',
  },
  {
    slug: 'tube',
    title: 'STAUFF Tube',
    description: 'View online or download the STAUFF Tube product catalogue.',
    imageUrl: `${IMAGE_BASE}/tube.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'flanges',
    title: 'STAUFF Flanges',
    description: 'View online or download the STAUFF Flanges product catalogue.',
    imageUrl: `${IMAGE_BASE}/flanges.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'hose-connectors',
    title: 'STAUFF Hose Connectors',
    description: 'View online or download the STAUFF Hose Connectors product catalogue.',
    imageUrl: `${IMAGE_BASE}/hose_connectors.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'quick-release-couplings',
    title: 'STAUFF Quick Release Couplings',
    description: 'View online or download the STAUFF Quick Release Couplings product catalogue.',
    imageUrl: `${IMAGE_BASE}/quick_release_couplings.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'valves',
    title: 'STAUFF Valves',
    description: 'View online or download the STAUFF Valves product catalogue.',
    imageUrl: `${IMAGE_BASE}/valves.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'test',
    title: 'STAUFF Test',
    description: 'View online or download the STAUFF Test product catalogue.',
    imageUrl: `${IMAGE_BASE}/test.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'diagtronics',
    title: 'STAUFF Diagtronics',
    description: 'View online or download the STAUFF Diagtronics product catalogue.',
    imageUrl: `${IMAGE_BASE}/diagtronics.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'filtration-technology',
    title: 'STAUFF Filtration Technology',
    description: 'View online or download the STAUFF Filtration Technology product catalogue.',
    imageUrl: `${IMAGE_BASE}/filtration_technology.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'hydraulic-accessories',
    title: 'STAUFF Hydraulic Accessories',
    description: 'View online or download the STAUFF Hydraulic Accessories product catalogue.',
    imageUrl: `${IMAGE_BASE}/hydraulic_accessories.jpg`,
    pdfUrl: null,
  },
  {
    slug: 'accumulators',
    title: 'STAUFF Accumulators',
    description: 'View online or download the STAUFF Accumulators product catalogue.',
    imageUrl: `${IMAGE_BASE}/accumulators.jpg`,
    pdfUrl: null,
  },
];

export const CATALOGUES_PATH = '/user/product-documents/stauff-catalogues';

export const getCatalogueBySlug = (slug) =>
  STAUFF_CATALOGUES.find((catalogue) => catalogue.slug === slug);
